'use client';

import { atomWithStorage } from 'jotai/utils';

export const currentVehicleIdAtom = atomWithStorage<string | null>('currentVehicleId', null);
